import React, { useRef, useEffect } from 'react';


type TimedButton = {
  style?: React.CSSProperties
  handleTenClicks?(): void
}
/**
 * 计数按钮
 */
function TimedButton(props: TimedButton) {
  const clickCount = useRef(0);
  const timeoutRef = useRef<any>(null);

  const handleTenClicks = () => {
    // 可以在这里调用你想触发的其他逻辑
    props.handleTenClicks && props.handleTenClicks()
  };

  const handleClick = () => {
    clickCount.current += 1;
    if (clickCount.current === 10) {
      handleTenClicks();
      clickCount.current = 0; // 满10次后重置
    }

    // 每点击一次，重置2秒倒计时
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      clickCount.current = 0; // 2秒内未点击自动重置
    }, 2000);
  };

  useEffect(() => {
    // 组件卸载时清除定时器
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div
      style={props.style}
      onClick={handleClick}
    />
  );
}

export default TimedButton;
